<div [hidden]="!loadingContent">
  <div class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
<div [hidden]="loadingContent">
  <ul ngbNav #editorNav="ngbNav" (navChange)="onDeviceUserPrinterCategoryTabChange($event)">
    <li [ngbNavItem]="'device-users-tab'">
      <a ngbNavLink>All Device Users</a>
      <ng-template ngbNavContent>
        <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
          <div class="row">
            <div class="col-6" *ngFor="let deviceUsersPriceListArray of tableDeviceUsersPriceList">
              <table class="table" style="display: block; overflow: auto;" *ngFor="let element of deviceUsersPriceListArray">
                <tbody>
                  <tr>
                    <td [attr.colspan]="(printers.length + 1)" class="border-0">
                      <h6 class="m-3">{{element.deviceUser.name}}</h6>
                    </td>
                  </tr>
                  <ng-container *ngFor="let category of element.printerCategory">
                    <ng-container *ngIf="element.deviceUser.deviceUserType.id !== 3 || (element.deviceUser.deviceUserType.id === 3 && !category.productCategory.id)"> <!-- this if exclude berichts-->
                      <tr>
                        <td><div>{{category.productCategory.name}}</div></td>
                        <td>
                          <div class="row">
                            <div *ngFor="let printer of printers" style="float:left; padding:3px 5px; margin:3px;">
                              <app-custom-switch-printer [printer]="printer" [deviceUsersPriceList]="element"
                                [printerCategory]="category" (onSwitchChange)="onCheckBoxChange($event)"
                                [eventFinished]="eventFinished">
                              </app-custom-switch-printer>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container >
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="'device-user-type-tab'" [disabled]="eventFinished">
      <a ngbNavLink>Device user type</a>
      <ng-template ngbNavContent>
        <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
          <div class="row">
            <div class="col-6" *ngFor="let deviceUsersTypePriceListArray of tableDeviceUsersTypePriceList">
              <table class="table" *ngFor="let element of deviceUsersTypePriceListArray">
                <tbody>
                  <div *ngIf="element.deviceUser.deviceUserType.id !== 3">
                    <tr>
                      <td [attr.colspan]="(printers.length + 1)" class="border-0">
                        <h6 class="m-3">{{element.deviceUser.deviceUserType.name}} ({{element.deviceUser.priceList.name}})</h6>
                      </td>
                    </tr>
                    <tr *ngFor="let category of element.printerCategory">
                      <ng-container *ngIf="category.productCategory.id">
                        <td><div>{{category.productCategory.name}}</div></td>
                        <td>
                          <div class="row">
                            <div *ngFor="let printer of printers" style="float:left; padding:3px 5px; margin:3px;">
                              <app-custom-switch-printer [printer]="printer" [deviceUsersPriceList]="element"
                                [printerCategory]="category" (onSwitchChange)="onDeviceTypeCheckBoxChange($event)">
                              </app-custom-switch-printer>
                            </div>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                  </div>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="'bericht-tab'" [disabled]="eventFinished">
      <a ngbNavLink>Bericht</a>
      <ng-template ngbNavContent>
        <div class="p-3" style="border: 1px solid #dee2e6; border-top: none;">
          <table class="table">
            <tbody>
              <tr>
                <td [attr.colspan]="(printers.length + 1)" class="border-0">
                  <h6 class="m-3">Bericht</h6>
                </td>
              </tr>
              <tr *ngFor="let category of berichtDeviceUsersByTypePriceList.printerCategory">
                <td><div>{{category.productCategory.name}}</div></td>
                <td>
                  <div class="row">
                    <div *ngFor="let printer of printers" style="float:left; padding:3px 5px; margin:3px;">
                      <app-custom-switch-printer [printer]="printer"
                        [deviceUsersPriceList]="berichtDeviceUsersByTypePriceList" [printerCategory]="category"
                        (onSwitchChange)="onBerichtCheckBoxChange($event)">
                      </app-custom-switch-printer>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="editorNav"></div>
  <div class="row">
    <div class="col">
      <div class="text-right mt-3">
        <button type="button" [hidden]="eventFinished" class="btn btn-danger btn-sm mr-2"
          (click)="onCancelButtonClick()"><i class="fa fa-times"></i>Cancel</button>
        <button type="button" [disabled]="eventFinished" class="btn btn-primary btn-sm"
          (click)="saveSettings()"><i class="fa fa-save"></i>
          Save</button>
      </div>
    </div>
  </div>
</div>
